/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger;

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');
        const deactivated = document.querySelectorAll('.mobile-menu__deactivated-link');

        //Init mmenu
        const menu = new Mmenu(mobileMenuSelector, {
            slidingSubmenus: true,
            navbar: false,
            offCanvas: {
                use: true,
                position: "right-front",
            },
            navbars: [
                {
                    position: "top",
                    content: ["<span class='mm-navbar__title-custom'>MENU</span>", "", "close"]
                }
            ]
        }, {
            offCanvas: {
                page: {
                    nodeType: "main",
                    selector: mainContentSelector
                }
            }
        });
        const mmenuApi = menu.API;

        // After init, grab the custom title element
        const navbarTitle = document.querySelector('.mm-navbar__title-custom');

        mmenuApi.bind("openPanel:after", (panel) => {
            const isSubPanel = panel.matches('.mm-panel--parent') === false
                && panel !== document.querySelector('.mm-panel:first-child');

            if (isSubPanel) {
                navbarTitle.textContent = "GO BACK";
                navbarTitle.style.cursor = "pointer";
                navbarTitle.onclick = () => mmenuApi.closePanel(panel);
            } else {
                navbarTitle.textContent = "MENU";
                navbarTitle.style.cursor = "default";
                navbarTitle.onclick = null;
            }
        });

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                mobileMenu.getBoundingClientRect();
                deactivated.forEach(event => {
                    event.addEventListener('click', () => {
                        event.nextElementSibling.click();
                    })
                })
                mmenuApi.open();
            }
        });

        // Close mmenu if screen width gets over breakpoint
        var mediaQuery = window.matchMedia("(min-width: 768px)");
        mediaQuery.addEventListener("change", function () {
            if (mmenuApi) {
                mmenuApi.close();
            }
        });
    };

    init();
}
